import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import { Skeleton } from '@mui/material'
import ButtonStartIcon from '../../../../../../button/ButtonStartIcon'
import IconTooltipButton from '../../../../../../button/IconTooltipButton'
import LinearProgressWithLabel from '../../../../../../commom/Loading/LinearProgressWithLabel'
import useAnalyticsCurriculum from '../../../../../../../hooks/analytics/useAnalyticsCurriculum'
import { useEffect } from 'react'

const BasicInformation = ({ setModal }) => {
  const curriculum = useSelector((state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum || {})
  const analytics = useSelector((state) => state?.analytics?.analyticsCurriculum?.datasets?.data || [])
  const isLoading = useSelector((state) => state?.analytics?.analyticsCurriculum?.isLoading || false)
  const progress = useSelector((state) => state?.analytics?.analyticsCurriculum?.progress || false)
  const isLoadingProgress = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.isLoadingProgress || false
  )
  const { getProgress } = useAnalyticsCurriculum()
  useEffect(() => {
    getProgress()
  }, [getProgress])

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Basic information
        </Typography>
      </Box>
      <Box className='px-2 pt-4 pb-4'>
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item md={3} sm={4}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Code
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <Typography>{isLoading ? <Skeleton /> : analytics?.code}</Typography>
          </Grid>
          <Grid item md={3} sm={4}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Name
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <Typography>{isLoading ? <Skeleton /> : analytics?.name}</Typography>
          </Grid>
          <Grid item md={3} sm={4}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Curriculum
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <Typography>
              {isLoading ? <Skeleton /> : `${curriculum?.shortName || ''} - ${curriculum?.name || ''}`}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Data generation process
        </Typography>
        <div className='flex gap-2 items-center'>
          <ButtonStartIcon
            color='secondary'
            size='small'
            startIcon='th-list'
            tooltip='Generate data'
            disabled={isLoading || isLoadingProgress || ['syncing', 'in-progress'].includes(progress?.status)}
            onClick={() =>
              setModal({
                show: true,
                type: 'generate-data',
                formData: {}
              })
            }
          >
            Generate data
          </ButtonStartIcon>
        </div>
      </Box>
      <Box className='px-2 pt-4 pb-4'>
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item md={3} sm={4}>
            <Typography variant='inherit' color='primary' className='font-bold ' align='right' component='p'>
              Status
            </Typography>
          </Grid>
          <Grid item md={1} sm={1}>
            <Typography className='uppercase text-nowrap'>
              {isLoading || isLoadingProgress ? <Skeleton /> : progress?.status}
            </Typography>
          </Grid>
          {!isLoadingProgress && progress?.status === 'syncing' && (
            <Grid item md={8} sm={7}>
              <LinearProgressWithLabel value={progress?.value || 0} />
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  )
}

export default BasicInformation
